import React from 'react'
import LogoHeader from '../../components/LogoHeader'
import LoginForm from '../../components/Login/LoginForm'

const Login = () => {
  return (
    <>
      <div>
        <LogoHeader />
        <LoginForm />
        {/* Login social */}
      </div>
    </>
  )
}

export default Login
